import React from "react";

import "./ShareButton.css";

import { useDispatch } from "react-redux";

import share from 'Assets/share.png';

const ShareButton = (props) => {
  // Refactor into share and guess button separate
  const dispatch = useDispatch();
  const { guessable, gameOver, incorrectGuesses, time, modal, score } = props;
  const className = `share-button ${guessable || gameOver ? "guessable" : ""} ${
    modal ? "modal" : ""
  }`;
  const minutes = Math.floor(time / 60);
  const seconds = time % 60 < 10 ? `0${time % 60}` : time % 60;
  // const url = CONFIG.WEB_APP_URI;
  const handleGuessClick = () => {
    if (navigator.share) {
      navigator
        .share({
          title: "Postcast",
          text: 'Play this game!',
          url: window.location.href
        })
        .then(() => {
          console.log("Thanks for sharing!");
        })
        .catch(console.error);
    } else {
      console.log("NO NAVI");
    }
  };
  return (
    <div className={className} onClick={handleGuessClick}>
      {"Share"} <img src={share} />
    </div>
  );
};

export default ShareButton;
